import React, { useState } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom"; // Use useNavigate instead of useHistory
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import TotalValue from "../data/TotalData.json";
import { Listing } from "../PageLayout/Summary/listing.jsx";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Summary() {
  const [data, setData] = useState(TotalValue);
  const navigate = useNavigate(); // Use navigate for going back
  const handleGoBack = () => {
    navigate(-1); // This will go back to the previous page in history
  };
  // Extract keys from the first data item for dynamic column headers
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.getAll("name").join("&"); // Remove the extra `urlParams`
  const details = urlParams.get("details");
  const node = urlParams.get("node");

  console.log(name);
  console.log(details);
  console.log(node);
  console.log(data);

  const validateDate =
    data && data.filter((item) => item.PrimaryType === `${details}`);
  const validateSecLayer =
    validateDate &&
    validateDate.filter((item) => item.SecondaryType === `${node}`);
  const validateModuleName =
    validateSecLayer &&
    validateSecLayer.filter((item) => item.ModuleName === `${name}`);

  console.log(validateModuleName);

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box
            className="mainLayout"
            sx={{ display: "flex", overflow: "hidden" }}
          >
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div style={{ width: "95%", margin: "auto" }}>
                <span
                  style={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "10px",
                    cursor: "pointer",
                    marginTop: "10px",
                    paddingLeft: "15px",
                  }}
                >
                  <a href="/">Home</a> /{" "}
                  <a href={`/details?name=${details}`}>{details} </a> /{" "}
                  <span> <a href={`/details?name=${details}`}>{node} </a> </span>/ {decodeURIComponent(name)}
                </span>

                {validateModuleName && validateModuleName.length !== 0 && (
                  <>
                    <Listing dataItem={validateModuleName || []}/>
                  </>
                )}

                {validateModuleName && validateModuleName.length === 0 && (
                  <>
                    There is no data available for this module {name}
                    Analysis
                  </>
                )}
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
